import styled from 'styled-components';
import CircleIconButton from '../../components/atoms/Buttons/CircleIconButton';
import Theme from '../../styles/models/theme';

export const Container = styled.div<{theme?: any}>`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${({theme}) => theme.lightBackground};
  text-align: center;
  margin-bottom: 30px;
`;

export const HeaderContainer = styled.div`
  margin-top: 22px;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
`;

export const Title = styled.text<{
  theme?: any;
}>`
  font-weight: bold;
  font-size: 30px;
  color: ${({theme}) => theme.background};
`;

export const ButtonsContainer = styled.div``;

export const IconButton = styled(CircleIconButton)`
  margin-left: 10px;
`;

export const BodyContainer = styled.div`
  flex-direction: column;
`;

export const Separator = styled.div<{theme: Theme}>`
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.chatSeparator};
  border-bottom-style: solid;
  margin-left: 16px;
  margin-right: 16px;
`;
